import React, { FC } from 'react';
import { t } from 'i18next';
import { Dropdown } from '@ui-modules/informed';
import { IDropdownOption } from '@ui-modules/types';
import { VehicleOwner } from '@common/interfaces';

interface IVehicleOwnerField {
  defaultValue?: VehicleOwner;
  disabled?: boolean;
}

const options: IDropdownOption[] = [
  { value: 'owned', label: t('mobility.owned') },
  { value: 'rented', label: t('mobility.rented') },
  { value: 'external_provide', label: t('mobility.externalProvider') },
];

const VehicleOwnerField: FC<IVehicleOwnerField> = ({ defaultValue, disabled }) => (
  <div className="field vehicle-owner">
    <Dropdown
      defaultValue={options.find((option) => option.value === defaultValue)}
      isDisabled={disabled}
      label={t('mobility.vehicleOwner')}
      name="vehicleOwner"
      options={options}
    />
  </div>
);

export default VehicleOwnerField;
